import { useEffect, useRef } from 'react';

import { t } from 'translations/src/LocaleContext';
import { Button } from 'ui';

import { useGetMemberDataExports } from '../../hooks/useGetMemberDataExports';
import { useInitMemberDataExport } from '../../hooks/useInitMemberDataExport';

const cta = t('membership_hub_data_export_cta');
const requestSent = t('membership_hub_data_export_cta_send');

export const InitiateButton = () => {
  const buttonRef = useRef<HTMLButtonElement>(null);
  const { data: mutationData, mutate, isPending } = useInitMemberDataExport();
  const { data, isFetching } = useGetMemberDataExports();
  const canInitiateNewExport = data?.canInitiateNewExport;
  const buttonDisabled = !canInitiateNewExport || isFetching || isPending;

  let buttonTextToUse = cta;
  // Change button text if we know canInitiateNewExport is false or if the mutation is pending.
  if ((!isFetching && !canInitiateNewExport) || isPending) {
    buttonTextToUse = requestSent;
  }

  // Accessibility focus helper to focus the button when an error occurs
  useEffect(() => {
    if (mutationData === 'REQUEST_FAILED' && buttonRef.current) {
      buttonRef.current.focus();
    }
  }, [mutationData]);

  return (
    <Button disabled={buttonDisabled} $margin="1rem 0 0" ref={buttonRef} onClick={() => mutate()}>
      {buttonTextToUse}
    </Button>
  );
};
